/**
 * Storage module - handles localStorage persistence
 */

const STORAGE_KEYS = {
  START_TIME: 'mp_stoper_start_time',
  FINISH_TIME: 'mp_stoper_finish_time',
  RESULTS: 'mp_stoper_results',
};

export const storage = {
  /**
   * Save race start time
   * @param {number} timestamp - Unix timestamp
   */
  saveStartTime(timestamp) {
    localStorage.setItem(STORAGE_KEYS.START_TIME, timestamp.toString());
  },

  /**
   * Get race start time
   * @returns {number|null}
   */
  getStartTime() {
    const time = localStorage.getItem(STORAGE_KEYS.START_TIME);
    return time ? parseInt(time, 10) : null;
  },

  /**
   * Save race finish time
   * @param {number} timestamp - Unix timestamp
   */
  saveFinishTime(timestamp) {
    localStorage.setItem(STORAGE_KEYS.FINISH_TIME, timestamp.toString());
  },

  /**
   * Get race finish time
   * @returns {number|null}
   */
  getFinishTime() {
    const time = localStorage.getItem(STORAGE_KEYS.FINISH_TIME);
    return time ? parseInt(time, 10) : null;
  },

  /**
   * Save results array
   * @param {Array} results - Array of result objects
   */
  saveResults(results) {
    localStorage.setItem(STORAGE_KEYS.RESULTS, JSON.stringify(results));
  },

  /**
   * Get results array
   * @returns {Array}
   */
  getResults() {
    const results = localStorage.getItem(STORAGE_KEYS.RESULTS);
    return results ? JSON.parse(results) : [];
  },

  /**
   * Clear all race data
   */
  clearAll() {
    localStorage.removeItem(STORAGE_KEYS.START_TIME);
    localStorage.removeItem(STORAGE_KEYS.FINISH_TIME);
    localStorage.removeItem(STORAGE_KEYS.RESULTS);
  },

  /**
   * Check if race is in progress
   * @returns {boolean}
   */
  isRaceInProgress() {
    return this.getStartTime() !== null && this.getFinishTime() === null;
  },
};
